export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';